export default __webpack_public_path__ + "static/media/chat.be0c5824.svg";